(function(){

  'use strict';

  function pxOverflowMenu() {
    return {
      restrict: 'EA',
      scope: {
        menuItems: '=menuItems', 
        callback: '&callback'
      },
      templateUrl: 'app/directives/overflowMenuDirective/overflow-menu.template.html',
      link: function(scope) {

        scope.menuItemsList = scope.menuItems.menuList;

        (function(){
          if (scope.menuItems.menuConfig.menuWidth) {
            angular.element('.dropdown-menu-override').css({width: scope.menuItems.menuConfig.menuWidth})
          }
        })();

        scope.selectMenuItem = function (menuItem) {
          scope.callback({menuItem: menuItem});
        }
      }
    };
  }

  pxOverflowMenu.$inject = [];

  angular
    .module('printix-admin')
    .directive('pxOverflowMenu', pxOverflowMenu);

})();
